export const BYTES_PER_KILOBYTES = 1024;
export const BYTES_PER_MEGABYTES = 1048576; // 1024 * 1024
export const BYTES_PER_GIGABYTES = 1073741824; // 1024 * 1024 * 1024